export const VIDEO_PROVIDERS = [
  {
    name: 'youtube',
    config: {
      playerVars: {
        autoplay: 1,
      },
    },
    // @ts-ignore
    component: () => import('./components/YouTubeVideo/index'),
  },
  {
    name: 'jwplayer',
    config: {
      autostart: true,
      mute: true,
    },
    // @ts-ignore
    component: () => import('./components/JwPlayer/index'),
  },
];

export const SHARE_PLATFORMS = [
  {
    id: 'facebook',
    name: 'Share on Facebook',
  },
  {
    id: 'twitter',
    name: 'Share on Twitter',
  },
  {
    id: 'whatsapp',
    name: 'Share on WhatsApp',
    mobileOnly: true,
  },
  {
    id: 'copylink',
    name: 'Copy Link',
  },
];
